<template>
  <div class="loading-loader">
    <div class="loading-text">
      <lottie
        :options="loading"
        class="anim"
        :height="getScreen ? 200 : 500"
        :width="getScreen ? 200 : 500"
      ></lottie>
    </div>
  </div>
</template>

<script>
import lottie from "vue-lottie";
import loading from "@/assets/anim/loading.json";
import { mapGetters } from "vuex";
export default {
  name: "loading",
  components: {
    lottie,
  },
  computed: {
    ...mapGetters([
      "getScreen"
    ]),
  },
  data() {
    return {
      loading: { animationData: loading, loop: true },
    };
  },
};
</script>

<style lang="less" scoped>
.loading {
  &-loader {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: fade(@color-dark, 70%);
    z-index: 900;
  }
  &-text {
    border: 2px solid whitesmoke;
    background-color: white;
    height: 100px;
    width: 200px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    overflow: hidden;
    font-size: 1.2rem;
    letter-spacing: 1px;

    &:after {
      content: "";
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      height: 4px;
      background-color: @color-primary;
    }
  }
}
</style>